import FormHelperText from '@anm/components/form/FormHelperText';
import RedeemCouponForm, {
  RedeemCouponFormFields
} from '@anm/components/form/RedeemCouponForm';
import usePageParams from '@anm/hooks/usePageParams';
import isString from 'lodash/fp/isString';
import { useCallback, FC } from 'react';

import { CardWrapper, Description } from './Wrapper';

export type RedeemWaveCouponProps = {
  onRedeem: (coupon: string) => void;
  error?: string;
};

const RedeemWaveCoupon: FC<RedeemWaveCouponProps> = ({ error, onRedeem }) => {
  const { redeem } = usePageParams();
  const redeemStr = isString(redeem) ? redeem : '';
  const handleSubmit = useCallback(
    ({ coupon }: RedeemCouponFormFields) => onRedeem(coupon),
    []
  );

  if (!redeem) return null;

  return (
    <CardWrapper>
      <Description>
        Receive a Wave.video Coupon Code from somewhere out there on the
        Internets? Enter it in the field below and redeem the power of the
        Wave.video gods!
      </Description>

      <RedeemCouponForm
        initialValues={{ coupon: redeemStr }}
        onSubmit={handleSubmit}
      />

      {error && <FormHelperText variant="static-left">{error}</FormHelperText>}
    </CardWrapper>
  );
};

export default RedeemWaveCoupon;
